<template>
  <div>
    <right-panel class="float-right" id="sidebar-new-electronic-storage" width="600px" :icon="'mdi mdi-plus'" :text="$t('electronic-storage.new')" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <h2>{{ $t("electronic-storage.library") }}</h2>

    <table class="table project-list-table table-centered table-borderless compact ">
      <tr>
        <th scope="col" style="width:300px">
          <sortable-table-head field="name" :text="$t('electronic-storage.name')" tag="span" :request="request" />
        </th>

        <th scope="col" style="width: 15%">
          <a href="javascript:;" @click="toggleFilter">
            <span v-if="filterEnabled" class="text-warning">
              <i class="bx bxs-filter-alt"></i>
              {{ $t("common.filters-hide") }}
            </span>
            <span v-else class="text-muted">
              <i class="bx bxs-filter-alt"></i>
              {{ $t("common.filters-show") }}
            </span>
          </a>
        </th>
      </tr>

      <tr v-if="filterEnabled">
        <th><input class="form-control " v-model="nameFilter" :placeholder="$t('common.search')" /></th>
        <th></th>
      </tr>
    </table>

    <div v-if="pagination" class="row">
      <div class="col-2 hider font-small" v-for="item in pagination.docs" :key="item._id">
        <div class="card text-center p-2">
          <div>
            <div class="mt-2 text-truncate hand">
              <h6 v-b-tooltip.hover :title="$options.filters.translate(item.name)">
                {{ item.name | translate }}
              </h6>
            </div>
          </div>
          <div v-if="hasUpdatePermission || hasRemovePermission" class="hidden">
            <div class="d-flex mt-3 team-social-links">
              <div v-if="hasUpdatePermission" class="flex-fill">
                <a @click="edit(item)" v-b-toggle="'sidebar-edit-organization-electronic-storage'" v-b-tooltip.hover :title="$t('common.edit')">
                  <i class="bx bx-pencil text-primary"></i>
                </a>
              </div>

              <div v-if="hasRemovePermission" class="flex-fill">
                <a href="javascript:;void(0);" @click="deleteById(item)" v-b-tooltip.hover :title="$t('common.delete')">
                  <i class="bx bx-trash-alt text-danger"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("electronic-storage.no") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import Form from "./organization-electronic-storage-form";

export default {
  components: { Form },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      filterEnabled: false,
    };
  },
  computed: {
    selectedEntity() {
      return this.$store.getters["organizationElectronicStorage/selectedEntity"];
    },
    pagination() {
      return this.$store.getters["organizationElectronicStorage/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationElectronicStorage/isLoading"];
    },
    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },
  mounted() {},
  methods: {
    init() {
      this.$store.dispatch("organizationElectronicStorage/resetForm");
      this.request.query = { parent: { value: null, isObject: true } }; //just root electronic-storage
    },

    async paginate() {
      await this.$store.dispatch("organizationElectronicStorage/paginate", this.request);
    },

    async findById(id) {
      await this.$store.dispatch("organizationElectronicStorage/findById", id);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationElectronicStorage/delete", item._id);
        this.init();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    edit(item) {
      this.$store.commit("organizationElectronicStorage/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-electronic-storage");
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 15, sort: { name: "asc" } },
          query: {},
        };
        this.nameFilter = undefined;
        this.categoryFilter = undefined;
      }
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.dispatch("organizationElectronicStorage/resetForm");
    },
  },
};
</script>
